/* global module, require */
const THREE = require('three');

module.exports = new THREE.MeshPhongMaterial({
	color: 0xd0d0d0,
	specular: 0xe0e0ff,
	shininess: 80,
});
